import { useSelector } from "react-redux";
export const useCheckFeature = (featureName: string): boolean => {
  const features = useSelector((state: any) => state.feature.features);
  if (!features || features.length === 0) {
    return false; // No features available
  }
  if (features.includes(featureName)) {
    return true;
  }
  return false;
};
